import { Box } from '@trmediaab/zebra';
import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import styled from 'styled-components';

import { FactSubHeading, PageTitle } from '~/components/Elements';
import { access_control } from '~/containers/Auth/AccessControl';
import { colors } from '~/utils/css-mixins';

import ReducedList from './ReducedList';
import SideList from './SideList';
import SystemList from './SystemList';

function getLeg(round, race_id, bet_type) {
  if (bet_type === 'TV' || bet_type === 'DD') {
    for (const leg of round.legs) {
      if (leg.race === race_id) {
        return leg.leg;
      }
    }
  }

  return null;
}

function getActiveSystems(round, systems, bet_type = null, premium = null) {
  let activeSystems = null;

  if (systems !== undefined) {
    let sortByLegNumber = false;

    systems.forEach(system => {
      let activeSystem = null;
      let systemIsOk = false;

      if (
        system.hasOwnProperty('jokersystem_xml') &&
        system.hasOwnProperty('jokersystem_url')
      ) {
        if (system.jokersystem_xml || system.jokersystem_url) {
          systemIsOk = true;
        }
      } else if (
        system.hasOwnProperty('cost') &&
        system.hasOwnProperty('bet_type')
      ) {
        if (system.cost && (!bet_type || bet_type === system.bet_type)) {
          systemIsOk = true;
        }
      } else {
        systemIsOk = true;
      }

      if (premium !== null && system.premium !== premium) {
        systemIsOk = false;
      }

      if (systemIsOk) {
        activeSystem = { ...system };
      }

      if (activeSystem) {
        if (system.bet_type === 'TV') {
          const race_id = Number.parseInt(
            Object.keys(activeSystem.data)[0],
            10,
          );
          activeSystem.leg_number = getLeg(round, race_id, system.bet_type);
          sortByLegNumber = true;
        } else if (system.bet_type === 'DD') {
          const race_ids = Object.keys(activeSystem.data);
          let data = [];

          for (let race_id of race_ids) {
            race_id = Number.parseInt(race_id, 10);
            const leg = getLeg(round, race_id, system.bet_type);
            data.push({
              ...activeSystem.data[race_id],
              leg_number: leg,
              race_id,
            });
          }

          data = orderBy(data, 'leg_number');
          activeSystem.data = data;
        }

        if (!activeSystems) {
          activeSystems = [];
        }

        activeSystems.push(activeSystem);
      }
    });

    if (sortByLegNumber) {
      activeSystems = orderBy(activeSystems, 'leg_number');
    }
  }

  return activeSystems;
}

const PublishText = styled.p`
  color: ${colors.textmeta};
  font-size: 14px;
  font-style: italic;
  line-height: 21px;
`;

export default access_control(
  class Systems extends Component {
    static propTypes = {
      round: PropTypes.object.isRequired,
    };

    render() {
      const { round } = this.props;
      const { systems, reduced_systems, side_bets, bet_type: betType } = round;

      const activePremiumSystems = getActiveSystems(round, systems, null, true);
      const activeFreeSystems = activePremiumSystems
        ? null
        : getActiveSystems(round, systems, null, false);
      const activeReducedSystems = getActiveSystems(round, reduced_systems);
      const activeDD = getActiveSystems(round, side_bets, 'DD');
      const activeTV = getActiveSystems(round, side_bets, 'TV');

      const isActive =
        activePremiumSystems ||
        activeFreeSystems ||
        activeReducedSystems ||
        activeDD ||
        activeTV;

      return (
        <Box bg="white" px={{ _: 3, md: '3,5' }} py={{ _: 3, md: '3,5' }}>
          <PageTitle>Våra spel</PageTitle>

          {isActive ? (
            <Fragment>
              {activePremiumSystems && (
                <div>
                  <FactSubHeading>
                    Matematiska system - {betType}
                  </FactSubHeading>
                  <SystemList round={round} systems={activePremiumSystems} />
                </div>
              )}
              {activeFreeSystems && (
                <div>
                  <FactSubHeading>
                    Preliminära matematiska system - {betType}
                  </FactSubHeading>
                  <SystemList round={round} systems={activeFreeSystems} />
                </div>
              )}
              {activeReducedSystems && (
                <div>
                  <FactSubHeading>Jokersystem - {betType}</FactSubHeading>
                  <ReducedList round={round} systems={activeReducedSystems} />
                </div>
              )}
              {activeDD && (
                <div>
                  <FactSubHeading>Dagens Dubbel</FactSubHeading>
                  <SideList round={round} systems={activeDD} bet_type="DD" />
                </div>
              )}
              {activeTV && (
                <div>
                  <FactSubHeading>Tvillingspel</FactSubHeading>
                  <SideList round={round} systems={activeTV} bet_type="TV" />
                </div>
              )}
            </Fragment>
          ) : (
            <PublishText>
              {betType === 'V75'
                ? 'Travronden Spels V75-system publiceras på torsdagar klockan 16.00.'
                : 'Systemen presenteras ca 30 min innan spelstopp.'}
            </PublishText>
          )}
        </Box>
      );
    }
  },
  'premium',
  'Våra spelförslag',
);
